module.exports = __webpack_public_path__ + "img/ROBOT_MV.df2392ea.png";